import {Component, OnInit} from '@angular/core';
import { Router } from '@angular/router';
import {NgbDropdownConfig} from '@ng-bootstrap/ng-bootstrap';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { UserService } from 'src/app/shared/user.service';
@Component({
  selector: 'app-nav-right',
  templateUrl: './nav-right.component.html',
  styleUrls: ['./nav-right.component.scss'],
  providers: [NgbDropdownConfig]
})
export class NavRightComponent implements OnInit {

  // user=environment.apiUrl;
   user:any={}
   id:any
  constructor(private router: Router,
    private http: HttpClient,private userService:UserService) { }

  ngOnInit() {
    //  this.user=localStorage.getItem("completeUserObject")
    this.id=JSON.parse(localStorage.getItem('completeUserObject'))
     console.log(this.id.username)
    this.userService.findUser(this.id.id).subscribe((data)=>{
      this.user=data
    })

   }
  logOut(){
    localStorage.clear();
    this.router.navigate(['/auth/signin']);
    // console.log(`${this.user}/api/users/login`)
  }
  profile(){
    this.router.navigate(['/user/profile'])
    console.log("profile")
  }
}
